"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var reactstrap_1 = require("reactstrap");
var Util_1 = require("../Services/Util");
var AuthenticationService_1 = require("../Services/AuthenticationService");
var LanguageSelector = /** @class */ (function (_super) {
    __extends(LanguageSelector, _super);
    function LanguageSelector(props) {
        return _super.call(this, props) || this;
    }
    LanguageSelector.prototype.onChange = function (culture) {
        var _this = this;
        fetch("/localization/SetLanguage?culture=" + culture)
            .then(function (response) {
            if (response.ok) {
                Util_1.getJson("/localization/GetResources", undefined, true, new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser()))
                    .then(function (response) {
                    var value = JSON.parse(response);
                    _this.props.applicationData.updateCallback("resources", value);
                });
                _this.props.applicationData.updateCallback("selectedLanguage", culture);
                //window.location.replace("/");
            }
            else {
                //TODO: Display error message to user
                console.error(response);
            }
        });
    };
    LanguageSelector.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.InputGroup, null,
            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                React.createElement(reactstrap_1.InputGroupText, { className: "bg-primary text-light" },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faGlobeAmericas }))),
            React.createElement(reactstrap_1.Input, { type: "select", name: "language", id: "languageSelect", onChange: function (e) { return _this.onChange(e.target.value); } },
                React.createElement("option", { key: this.props.applicationData.selectedLanguage, hidden: true }, this.props.applicationData.supportedLanguages[this.props.applicationData.selectedLanguage]),
                Object.keys(this.props.applicationData.supportedLanguages).map(function (key) {
                    if (key != _this.props.applicationData.selectedLanguage) {
                        return React.createElement("option", { key: key, value: key }, _this.props.applicationData.supportedLanguages[key]);
                    }
                }))));
    };
    return LanguageSelector;
}(React.Component));
exports.LanguageSelector = LanguageSelector;
//# sourceMappingURL=LanguageSelector.js.map